import React, { useState } from "react";
import QRCode from "react-qr-code";

const ServiceCard = () => {
  const containerStyle = {
    // minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "16px",
    // backgroundColor: "#F3F4F6",
  };

  const wrapperStyle = {
    width: "100%",
    maxWidth: "97vw",
  };

  return (
    <div style={containerStyle}>
      <div style={wrapperStyle}>
        <CardItem
          name="John Doe"
          position="Creative Manager"
          idNumber="0000000"
          joinedDate="01/01/2024"
          email="john.doe@example.com"
          dob="15/05/1990"
          expireDate="01/01/2026"
          phone="555-123-4567"
          qrValue="https://example.com/johndoe"
        />
      </div>
    </div>
  );
};
export default ServiceCard;

const CardItem = ({
  id = "12345",
  name = "John Doe",
  position = "Creative Manager",
  idNumber = "0000000",
  joinedDate = "DD/MM/YEAR",
  email = "your.mail.goes.here@example.com",
  dob = "DD/MM/YEAR",
  expireDate = "DD/MM/YEAR",
  phone = "000-000-00",
  qrValue = "https://example.com/profile/12345",
}) => {
  const [avatar, setAvatar] = useState(null > null);
  const [showAvatarEdit, setShowAvatarEdit] = useState(false);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [tempAvatar, setTempAvatar] = useState(null > null);
  const [zoom, setZoom] = useState(100);
  const [brightness, setBrightness] = useState(100);
  const [contrast, setContrast] = useState(100);

  const handleAvatarChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onload = (event) => {
        if (event.target?.result) {
          setTempAvatar(event.target.result);
          setIsEditDialogOpen(true);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const applyChanges = () => {
    setAvatar(tempAvatar);
    setIsEditDialogOpen(false);
    resetImageSettings();
  };

  const cancelChanges = () => {
    setIsEditDialogOpen(false);
    setTempAvatar(null);
    resetImageSettings();
  };

  const resetImageSettings = () => {
    setZoom(100);
    setBrightness(100);
    setContrast(100);
  };

  // CSS for the card container
  const cardStyle = {
    width: "100%",
    maxWidth: "90vw",
    margin: "0 auto",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
    fontFamily: "Arial, sans-serif",
    backgroundColor: "#ffffff",
  };

  // CSS for the header
  const headerStyle = {
    backgroundColor: "#192F59",
    padding: "16px",
    textAlign: "center",
    color: "#FFFFFF",
  };

  // CSS for the content container
  const contentStyle = {
    padding: "16px",
    backgroundColor: "#FFFFFF",
  };

  // CSS for the avatar container
  const avatarContainerStyle = {
    position: "relative",
    marginRight: "16px",
  };

  // CSS for the avatar
  const avatarStyle = {
    width: "96px",
    height: "96px",
    borderRadius: "50%",
    border: "2px solid #E0E0E0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "24px",
    color: "#FFFFFF",
    backgroundColor: "#192F59",
    overflow: "hidden",
  };

  // CSS for the avatar image
  const avatarImageStyle = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  };

  // CSS for the avatar edit overlay
  const avatarEditOverlayStyle = {
    position: "absolute",
    inset: "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    borderRadius: "50%",
    cursor: "pointer",
  };

  // CSS for the user info container
  const userInfoStyle = {
    flex: "1",
  };

  // CSS for the name
  const nameStyle = {
    fontSize: "24px",
    fontWeight: "bold",
    margin: "0 0 4px 0",
  };

  // CSS for the position
  const positionStyle = {
    fontSize: "14px",
    color: "#666666",
    margin: "0",
  };

  // CSS for the QR code container
  const qrCodeContainerStyle = {
    marginLeft: "auto",
    width: "80px",
    height: "80px",
  };

  // CSS for the flex container
  const flexContainerStyle = {
    display: "flex",
  };

  // CSS for the details grid
  const detailsGridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "8px",
    marginTop: "16px",
    fontSize: "14px",
  };

  // CSS for the label
  const labelStyle = {
    color: "#E53E3E",
    fontWeight: "bold",
    marginBottom: "4px",
  };

  // CSS for the signature container
  const signatureStyle = {
    marginTop: "16px",
    textAlign: "right",
    fontWeight: "bold",
  };

  // CSS for the modal background
  const modalBackgroundStyle = {
    display: isEditDialogOpen ? "flex" : "none",
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  };

  // CSS for the modal content
  const modalContentStyle = {
    backgroundColor: "#FFFFFF",
    borderRadius: "8px",
    padding: "20px",
    width: "90%",
    maxWidth: "500px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  };

  // CSS for the modal header
  const modalHeaderStyle = {
    borderBottom: "1px solid #E0E0E0",
    paddingBottom: "10px",
    marginBottom: "20px",
  };

  // CSS for the modal title
  const modalTitleStyle = {
    margin: 0,
    fontSize: "18px",
    fontWeight: "bold",
  };

  // CSS for the modal image container
  const imageContainerStyle = {
    width: "192px",
    height: "192px",
    margin: "0 auto",
    borderRadius: "50%",
    overflow: "hidden",
    border: "2px solid #E0E0E0",
  };

  // CSS for the image preview with filters
  const imageStyle = {
    filter: `brightness(${brightness}%) contrast(${contrast}%)`,
    transform: `scale(${zoom / 100})`,
    transformOrigin: "center",
    width: "100%",
    height: "100%",
    objectFit: "cover",
  };

  // CSS for the slider container
  const sliderContainerStyle = {
    marginTop: "20px",
  };

  // CSS for the slider group
  const sliderGroupStyle = {
    marginBottom: "15px",
  };

  // CSS for the slider label
  const sliderLabelStyle = {
    display: "block",
    marginBottom: "5px",
    fontSize: "14px",
    fontWeight: "bold",
  };

  // CSS for the slider
  const sliderStyle = {
    width: "100%",
    accentColor: "#192F59",
  };

  // CSS for the button container
  const buttonContainerStyle = {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "20px",
  };

  // CSS for the buttons
  const buttonStyle = {
    padding: "8px 16px",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontWeight: "bold",
  };

  // CSS for the cancel button
  const cancelButtonStyle = {
    ...buttonStyle,
    backgroundColor: "#F56565",
    color: "white",
  };

  // CSS for the reset button
  const resetButtonStyle = {
    ...buttonStyle,
    backgroundColor: "#E2E8F0",
    color: "#4A5568",
  };

  // CSS for the apply button
  const applyButtonStyle = {
    ...buttonStyle,
    backgroundColor: "#192F59",
    color: "white",
  };

  return (
    <div style={cardStyle}>
      {/* Header - Company Logo */}
      <div style={headerStyle}>
        <h2 style={{ fontSize: "18px", fontWeight: "bold", margin: 0 }}>
          COMPANY LOGO
        </h2>
      </div>

      <div style={contentStyle}>
        <div style={flexContainerStyle}>
          {/* Left side - Avatar */}
          <div
            style={avatarContainerStyle}
            onMouseEnter={() => setShowAvatarEdit(true)}
            onMouseLeave={() => setShowAvatarEdit(false)}
          >
            <div style={avatarStyle}>
              {avatar ? (
                <img src={avatar} alt={name} style={avatarImageStyle} />
              ) : (
                <div>
                  {name
                    .split(" ")
                    .map((n) => n[0])
                    .join("")}
                </div>
              )}
            </div>

            {showAvatarEdit && (
              <div style={avatarEditOverlayStyle}>
                <label htmlFor="avatar-upload" style={{ cursor: "pointer" }}>
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={{ color: "white" }}
                  >
                    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
                    <circle cx="12" cy="13" r="4"></circle>
                  </svg>
                </label>
                <input
                  id="avatar-upload"
                  type="file"
                  accept="image/*"
                  onChange={handleAvatarChange}
                  style={{ display: "none" }}
                />
              </div>
            )}
          </div>

          {/* Right side - Basic Info */}
          <div style={userInfoStyle}>
            <h1 style={nameStyle}>{name}</h1>
            <p style={positionStyle}>{position}</p>

            <div
              style={{
                marginTop: "8px",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <div style={qrCodeContainerStyle}>
                <QRCode
                  value={qrValue}
                  size={80}
                  style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                  viewBox={`0 0 256 256`}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Details Grid */}
        <div style={detailsGridStyle}>
          {/* Row 1 */}
          <div>
            <p style={labelStyle}>ID No.</p>
            <p style={{ margin: 0 }}>{idNumber}</p>
          </div>
          <div>
            <p style={labelStyle}>Joined Date</p>
            <p style={{ margin: 0 }}>{joinedDate}</p>
          </div>
          <div>
            <p style={labelStyle}>Email</p>
            <p
              style={{
                margin: 0,
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {email}
            </p>
          </div>

          {/* Row 2 */}
          <div>
            <p style={labelStyle}>D.O.B</p>
            <p style={{ margin: 0 }}>{dob}</p>
          </div>
          <div>
            <p style={labelStyle}>Expire Date</p>
            <p style={{ margin: 0 }}>{expireDate}</p>
          </div>
          <div>
            <p style={labelStyle}>Phone</p>
            <p style={{ margin: 0 }}>{phone}</p>
          </div>
        </div>

        <div style={signatureStyle}>
          <p>Your Sincerely</p>
        </div>
      </div>

      {/* Image Edit Dialog */}
      <div style={modalBackgroundStyle}>
        <div style={modalContentStyle}>
          <div style={modalHeaderStyle}>
            <h3 style={modalTitleStyle}>Edit Avatar</h3>
          </div>

          <div style={{ textAlign: "center" }}>
            {tempAvatar && (
              <div style={imageContainerStyle}>
                <img src={tempAvatar} alt="Avatar Preview" style={imageStyle} />
              </div>
            )}

            <div style={sliderContainerStyle}>
              <div style={sliderGroupStyle}>
                <label style={sliderLabelStyle}>Zoom</label>
                <input
                  type="range"
                  min="50"
                  max="150"
                  step="1"
                  value={zoom}
                  onChange={(e) => setZoom(Number(e.target.value))}
                  style={sliderStyle}
                />
              </div>

              <div style={sliderGroupStyle}>
                <label style={sliderLabelStyle}>Brightness</label>
                <input
                  type="range"
                  min="50"
                  max="150"
                  step="1"
                  value={brightness}
                  onChange={(e) => setBrightness(Number(e.target.value))}
                  style={sliderStyle}
                />
              </div>

              <div style={sliderGroupStyle}>
                <label style={sliderLabelStyle}>Contrast</label>
                <input
                  type="range"
                  min="50"
                  max="150"
                  step="1"
                  value={contrast}
                  onChange={(e) => setContrast(Number(e.target.value))}
                  style={sliderStyle}
                />
              </div>
            </div>
          </div>

          <div style={buttonContainerStyle}>
            <button style={cancelButtonStyle} onClick={cancelChanges}>
              Cancel
            </button>
            <button style={resetButtonStyle} onClick={resetImageSettings}>
              Reset
            </button>
            <button style={applyButtonStyle} onClick={applyChanges}>
              Apply
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
